import { PAYMENT_FLOW_TYPE } from '../../../../../shared/constants/user-info/paymentFlowType';
import { SOLUTION_TYPE } from '../../../../../shared/constants/user-info/solutionType';
import { EntityListFormValues } from '../../../../interfaces/entity-list/EntityListFilters';
import { LIST_MODE, ListMode } from '../../NgzEntityList.settings';

export type TabFilterValue = Pick<EntityListFormValues, 'paymentFlowType' | 'solutions'>;

type EntityListFilterOption = {
  label: string;
  value: TabFilterValue;
};

export const nutritionFilterConfig: EntityListFilterOption[] = [
  {
    label: 'All',
    value: {
      paymentFlowType: '',
      solutions: [],
    },
  },
  {
    label: 'New Flow 2024',
    value: {
      paymentFlowType: PAYMENT_FLOW_TYPE.NEW_USER_FLOW_2024,
      solutions: [],
    },
  },
  {
    label: 'New Flow',
    value: {
      paymentFlowType: PAYMENT_FLOW_TYPE.NEW,
      solutions: [],
    },
  },
  {
    label: 'Old Flow',
    value: {
      paymentFlowType: PAYMENT_FLOW_TYPE.OLD,
      solutions: [],
    },
  },
];

export const scanIQFilterConfig: EntityListFilterOption[] = [
  {
    label: 'All',
    value: {
      paymentFlowType: '',
      solutions: [],
    },
  },
  {
    label: 'Nutrition & ScanIQ',
    value: {
      paymentFlowType: '',
      solutions: [
        SOLUTION_TYPE.NUTRITION,
        SOLUTION_TYPE.SCAN_IQ,
        SOLUTION_TYPE.CHALLENGE,
      ],
    },
  },
  {
    label: 'ScanIQ',
    value: {
      paymentFlowType: '',
      solutions: [SOLUTION_TYPE.SCAN_IQ, SOLUTION_TYPE.CHALLENGE],
    },
  },
];

export const filterConfig: Record<ListMode, EntityListFilterOption[]> = {
  [LIST_MODE.NUTRITION]: nutritionFilterConfig,
  [LIST_MODE.SCAN_IQ]: scanIQFilterConfig,
};
